import React from 'react'
import './Sales.css'
import { Typography, Paper } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { MatrixGoldIcon, CounterSketchIcon, ClayooIcon, RhinoNestIcon } from '../../constants'

const renderProductList = (productsList: any) => {
  return productsList.map((item: any, index: number) => {
    switch (item) {
      case 'MatrixGold':
        return <img key={index} src={MatrixGoldIcon} alt={item} title={item} style={{ padding: 6, maxWidth: 30 }} />
      case 'CounterSketch':
      case 'CounterSketch Studio':
        return <img key={index} src={CounterSketchIcon} alt={item} title={item} style={{ padding: 4, maxWidth: 30 }} />
      case 'Clayoo':
        return <img key={index} src={ClayooIcon} alt={item} title={item} style={{ padding: 5, maxWidth: 30 }} />
      case 'RhinoNest':
        return (
          <img
            key={index}
            src={RhinoNestIcon.src}
            width={RhinoNestIcon.width}
            height={RhinoNestIcon.height}
            alt={item}
            title={item}
            style={{ margin: 5, maxWidth: 30 }}
          />
        )
      default:
        return null
    }
  })
}

export default function ContactUsSellers(props: any) {
  const { name, bioImagePath, email, tollFreePhone, fax, productsList } = props
  return (
    <Paper className='contact-wrapper' data-cy='contact-container'>
      <div className='sales-contact-image'>
        <img src={bioImagePath} alt={name} />
      </div>
      <div className='contact-text'>
        <div className='contact-row'>
          <div className='contact-title'>
            <Typography variant='body2'>
              <FormattedMessage id='account.contact' />
            </Typography>
          </div>
          <div className='contact-content'>
            <Typography>{name}</Typography>
          </div>
        </div>
        <div className='contact-row'>
          <div className='contact-title'>
            <Typography variant='body2'>
              <FormattedMessage id='account.email' />
            </Typography>
          </div>
          <div className='contact-content'>
            <Typography>
              <a href={'mailto:' + email}>{email}</a>
            </Typography>
          </div>
        </div>
        <div className='contact-row'>
          <div className='contact-title'>
            <Typography variant='body2'>
              <FormattedMessage id='account.phone' />
            </Typography>
          </div>
          <div className='contact-content'>
            <Typography>{tollFreePhone}</Typography>
          </div>
        </div>
        {fax && (
          <div className='contact-row'>
            <div className='contact-title'>
              <Typography variant='body2'>
                <FormattedMessage id='account.fax' />
              </Typography>
            </div>
            <div className='contact-content'>
              <Typography>{fax}</Typography>
            </div>
          </div>
        )}
        <div className='contact-row'>
          <div className='contact-title'>
            <Typography variant='body2'>
              <FormattedMessage id='account.products' />
            </Typography>
          </div>
          <div className='contact-content'>{renderProductList(productsList)}</div>
        </div>
      </div>
    </Paper>
  )
}
